export default "__VITE_ASSET__1f947915__"